import cx from 'classnames';
import parseHTML from 'html-react-parser';
import type {FC} from 'react';
import {Breadcrumb} from '~/GalleryPB/components/Breadcrumb';
import {PageTitle} from '~/GalleryPB/components/PageTitle';
import type {BreadcrumbPath, Relative} from '~/GalleryPB/types/gallery';
import {showSeoHeader} from '~/GalleryPB/utils';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {RelatedCategoriesPills} from './RelatedCategoriesPills/RelatedCategoriesPills';

interface HeaderProps {
  crumbPath: BreadcrumbPath[];
  pageTitle?: string;
  numTemplates?: number;
  relatedCategories: Relative[];
}

export const Header: FC<HeaderProps> = ({
  crumbPath,
  pageTitle,
  numTemplates,
  relatedCategories,
}) => {
  const largeScreens = useIsLargishAndUp();

  return (
    <div className={cx('gallery__header', {'seo-heading': showSeoHeader})} id="gallery-header">
      {!showSeoHeader && (
        <>
          <Breadcrumb path={crumbPath} />
          <div className="gallery__title-filters-wrapper">
            {pageTitle && numTemplates !== undefined && (
              <PageTitle text={pageTitle} numTemplates={numTemplates} />
            )}
          </div>
        </>
      )}
      {window.webflow_content && (
        <div id="category_webflow">{parseHTML(window.webflow_content)}</div>
      )}
      {largeScreens && <RelatedCategoriesPills categories={relatedCategories} />}
    </div>
  );
};
